import { KeylineText } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-themes';
import styled from 'styled-components';
import useSocialAuthLocale from '~/client/features/SocialAuth/hooks/useSocialAuthLocale';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  isStepByStepRegistrationEnabled?: boolean;
};

const KeylineTextLowerCase = styled(KeylineText)`
  && {
    text-transform: none;
    font-size: ${rem(12)};
    font-weight: 400;
  }
`;

const SocialsKeyLineText: FC<Props> = ({ isStepByStepRegistrationEnabled }) => {
  const [, setLocale] = useSocialAuthLocale();
  setLocale();
  const textId = isStepByStepRegistrationEnabled
    ? 'general.or_continue_with'
    : 'general.or';

  if (isStepByStepRegistrationEnabled) {
    return (
      <KeylineTextLowerCase>
        <Translate id={textId} />
      </KeylineTextLowerCase>
    );
  }
  return (
    <KeylineText>
      <Translate id={textId} />
    </KeylineText>
  );
};

export default SocialsKeyLineText;
